export function initStickyCTA(): void {
  const stickyCTA = document.querySelector('.sticky-cta');
  const heroSection = document.querySelector('.hero');

  if (!stickyCTA || !heroSection) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyCTA.classList.remove('visible');
        } else {
          stickyCTA.classList.add('visible');
        }
      });
    },
    { threshold: 0.1 },
  );

  observer.observe(heroSection);
}
